import { lazy } from 'react';

const PublicWebsite = lazy(() => import('app/pages/public/website/PublicWebsite'));

const publicRoutes = {
  id: "public",
  children: [
    {
      path: "website",
      element: <PublicWebsite />,
    },
  ],
};

export { publicRoutes };
